import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatNameString, getColorByStatus } from '../tools';
import { ClaimService } from 'src/app/services/claim.service';
import { CommonService } from 'src/app/services/common.service';
export const columns = [
  { key: 'claimNumber', name: formatNameString('claimNumber'), visible: true },
  { key: 'workflowId', name: formatNameString('workflowId'), visible: true },
  { key: 'claimStatus', name: formatNameString('claimStatus'), visible: true },
  {
    key: 'claimCategory',
    name: formatNameString('claimCategory'),
    visible: true,
  },
  { key: 'claimType', name: formatNameString('claimType'), visible: true },
  {
    key: 'claimSubmitTime',
    name: formatNameString('claimSubmitDate'),
    visible: true,
  },
  { key: 'claimValue', name: formatNameString('claimValue'), visible: true },
  {
    key: 'activeApprover',
    name: formatNameString('activeApprover'),
    visible: true,
  },
];
@Component({
  selector: 'claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.less'],
})
export class ClaimComponent implements OnInit {
  dateFormat = 'yyyy-MM-dd';
  getColorByStatus = getColorByStatus;
  overViewTitle: string = '2024 Jan - 2024 May Overview';
  chartData = [
    { label: 'Draft', value: 0, color: '#EFF1F2' },
    { label: 'In Progress', value: 0, color: '#007BC0' },
    { label: 'Approved', value: 0, color: '#419E98' },
    { label: 'Rejected', value: 0, color: '#F19F23' },
  ];
  totalClaim = 0;
  searchFormData!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private claimService: ClaimService,
    private commonService: CommonService
  ) {}
  columns: any[] = columns;
  dataSource: any[] = [];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getTableOverView();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getTableOverView();
  }

  handleSearch() {
    this.pagination.pageIndex = 1;
    this.getTableOverView();
  }
  getOverViewChart() {
    this.claimService.apiClaimOverview().subscribe((result: any) => {
      const res = result?.rtnData;
      const { start, end, totalClaim } = res;
      this.overViewTitle = `${start} - ${end} Overview`;
      this.totalClaim = totalClaim;
      this.chartData.forEach((item) => {
        const label = item.label;
        switch (label) {
          case 'Draft':
            item.value = res.draftClaim;
            break;
          case 'In Progress':
            item.value = res.inProgressClaim;
            break;
          case 'Approved':
            item.value = res.approvedClaim;
            break;
          case 'Rejected':
            item.value = res.rejectedClaim;
            break;
          default:
            break;
        }
      });
    });
  }
  getTableOverView() {
    const params = { ...this.searchFormData.value };
    params.claimStartDate = this.searchFormData.value.timePeriod
      ? this.commonService.formatDateString(
          this.searchFormData.value.timePeriod[0]
        ) ?? ''
      : '';
    params.claimEndDate = this.searchFormData.value.timePeriod
      ? this.commonService.formatDateString(
          this.searchFormData.value.timePeriod[1]
        ) ?? ''
      : '';
    const req = {
      param: params,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
    };
    this.claimService.apiClaimPage(req).subscribe((result: any) => {
      const { rows, total } = result.rtnData;
      this.dataSource = rows;
      this.pagination.total = total;
    });
  }
  ngOnInit(): void {
    this.searchFormData = this.fb.group({
      claimNumber: ['', []],
      timePeriod: [[], []],
      claimCategory: ['', []],
      activeApprover: ['', []],
    });

    this.getOverViewChart();
    this.getTableOverView();
  }
  checked = false;
  setOfCheckedId = new Set<number>();
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  refreshCheckedStatus(): void {
    const listOfEnabledData = this.dataSource.filter(
      ({ disabled }) => !disabled
    );
    this.checked = listOfEnabledData.every(({ id }) =>
      this.setOfCheckedId.has(id)
    );
  }
  onAllChecked(checked: boolean): void {
    this.dataSource.forEach(({ id }) => this.updateCheckedSet(id, checked));
    this.refreshCheckedStatus();
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
}
